module.exports = __webpack_public_path__ + "img/forest_en.1dfc1268.svg";